import { onUnmounted, watch, type Ref } from 'vue'

let lockCount = 0
let savedScrollY = 0

function lockBody() {
  if (typeof document === 'undefined') return
  lockCount++
  if (lockCount > 1) return
  savedScrollY = window.scrollY || document.documentElement.scrollTop || 0
  document.documentElement.classList.add('body-scroll-locked')
  document.body.style.position = 'fixed'
  document.body.style.top = `-${savedScrollY}px`
  document.body.style.left = '0'
  document.body.style.right = '0'
  document.body.style.width = '100%'
}

function unlockBody() {
  if (typeof document === 'undefined') return
  lockCount = Math.max(0, lockCount - 1)
  if (lockCount > 0) return
  clearBodyLockStyles()
  window.scrollTo(0, savedScrollY)
}

function clearBodyLockStyles() {
  document.documentElement.classList.remove('body-scroll-locked')
  document.body.style.position = ''
  document.body.style.top = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.width = ''
}

/** 路由切换等场景强制解除滚动锁，防止 SPA 跳转后 body 仍 position:fixed */
export function forceUnlockBody() {
  if (typeof document === 'undefined') return
  const top = document.body.style.top
  lockCount = 0
  clearBodyLockStyles()
  if (top) {
    const y = Math.abs(parseInt(top, 10) || 0)
    window.scrollTo(0, y)
  }
}

/** 锁定/恢复页面滚动（支持多处同时引用，引用计数归零后恢复） */
export function useBodyScrollLock(active: Ref<boolean> | (() => boolean)) {
  const getActive = typeof active === 'function' ? active : () => active.value

  watch(
    () => getActive(),
    (val) => {
      if (val) lockBody()
      else unlockBody()
    },
    { immediate: true },
  )

  onUnmounted(() => {
    if (getActive()) unlockBody()
  })
}
